import { render, staticRenderFns } from "./updateVersion.vue?vue&type=template&id=48cc5f3a&scoped=true"
import script from "./updateVersion.vue?vue&type=script&lang=js"
export * from "./updateVersion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48cc5f3a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48cc5f3a')) {
      api.createRecord('48cc5f3a', component.options)
    } else {
      api.reload('48cc5f3a', component.options)
    }
    module.hot.accept("./updateVersion.vue?vue&type=template&id=48cc5f3a&scoped=true", function () {
      api.rerender('48cc5f3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/appSet/components/updateVersion.vue"
export default component.exports